import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

const SleepChartHelpIcon: FC = () => {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <Typography variant="body1" className={classes.text}>
          Estimated bedtime, waketime, and time sleeping each night. Sleep is
          calculated as the longest period of time the phone is not in use.
          Nights where estimated times fall outside the expected range are not
          displayed, though data may still have been collected.
        </Typography>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default SleepChartHelpIcon
